export enum EntityToDeleteTypes {
  Assembly = 'assembly',
  Component = 'component',
  CustomComponent = 'custom-component',
  Function = 'function',
  Sua = 'sua',
  Reference = 'reference',
  URL = 'url'
}
